const isBlank = (value) => {
  return value === undefined || value === null || String(value).trim() === '';
};

export function historyValue(row, keys, fallback = '-') {
  const value = keys.reduce((found, key) => (found ?? row?.[key]), undefined);
  return isBlank(value) ? fallback : value;
}

export function historyDate(row) {
  return historyValue(row, ['exam_dt', 'examDt', 'examDate', 'exam_date', 'created_at', 'createdAt']);
}

export function historyEye(row) {
  return historyValue(row, ['eye', 'eyeSide', 'eye_side']);
}

export function historyOpMR(row) {
  const sphere = historyValue(row, ['opmr_sphere', 'opmrSphere', 'sphere'], '');
  const cylinder = historyValue(row, ['opmr_cylinder', 'opmrCylinder', 'cylinder'], '');
  return sphere || cylinder ? `${sphere}/${cylinder}` : '-';
}

export function historyRowKey(row, index) {
  return `${historyDate(row)}-${historyEye(row)}-${historyValue(row, ['id', 'seq', 'examId'], index)}`;
}

export function extractHistoryRows(response) {
  if (Array.isArray(response)) return response;

  const candidates = [response?.result, response?.data, response?.items, response?.rows];
  return candidates.find(Array.isArray) || [];
}

export function historyToForm(row, currentForm) {
  const value = (keys) => {
    const found = keys.reduce((result, key) => (result ?? row?.[key]), undefined);
    return isBlank(found) ? undefined : String(found);
  };
  const orientation = value(['orientation']) || currentForm.orientation;
  const casiaPrefix = orientation === '수직' ? 'v' : 'h';
  const next = {
    ...currentForm,
    chart_no: value(['chart_no', 'chartNo']) || currentForm.chart_no,
    eye: value(['eye', 'eyeSide', 'eye_side']) || currentForm.eye,
    gender: value(['gender', 'sex']) || currentForm.gender,
    birth_date: value(['birth_date', 'birthDate']) || currentForm.birth_date,
    age_years: value(['age_years', 'ageYears', 'age']),
    orientation,
    opmr_sphere: value(['opmr_sphere', 'opmrSphere', 'sphere']),
    opmr_cylinder: value(['opmr_cylinder', 'opmrCylinder', 'cylinder']),
    opmr_axis: value(['opmr_axis', 'opmrAxis', 'axis']),
    k1: value(['k1', 'K1']),
    k_axis: value(['k_axis', 'kAxis', 'k1_axis', 'k1Axis']),
    k2: value(['k2', 'K2']),
    acd_preop: value(['acd_preop', 'acdPreop', 'acd']),
    wtw: value(['wtw', 'WTW']),
    ct: value(['ct', 'CT']),
    exp_se: value(['exp_se', 'expSe']),
    casia_acw: value([`casia_${casiaPrefix}_acw_mm`, 'casia_acw', 'casiaAcw']),
    casia_clr: value([`casia_${casiaPrefix}_clr_um`, 'casia_clr', 'casiaClr']),
    casia_ata: value([`casia_${casiaPrefix}_ata_mm`, 'casia_ata', 'casiaAta']),
    casia_acd: value([`casia_${casiaPrefix}_acd_mm`, 'casia_acd', 'casiaAcd'])
  };

  return Object.fromEntries(Object.entries(next).map(([key, item]) => [key, item === undefined ? currentForm[key] : item]));
}
